module.exports = __webpack_public_path__ + "img/gr.d1708a2a.svg";